import { useTranslation } from 'react-i18next'

import { ArrowUDownLeftIcon } from '@phosphor-icons/react'

import { Alert } from '@reveni-io/reveni-ui'

import NoResultsFound from '@/common/components/NoResultsFound/NoResultsFound'

import ReturnSalesChart from './ReturnSalesChart/ReturnSalesChart'
import ReturnSalesData from './ReturnSalesData/ReturnSalesData'
import ReturnSalesRatioContentSkeleton from './ReturnSalesRatioContentSkeleton/ReturnSalesRatioContentSkeleton'
import * as Styles from './styles'

const ReturnSalesRatioContent = ({ data, metrics, filters, loading, setChartFilters }) => {
  const { t } = useTranslation()

  const handleChangeTimeDisplay = value => {
    setChartFilters(prev => ({ ...prev, timeDisplayReturnSales: value }))
  }

  if (loading) return <ReturnSalesRatioContentSkeleton />

  return (
    <Styles.MainContainer>
      <Styles.Container>
        <ReturnSalesData
          metrics={metrics}
          total={data?.[metrics.total.summaryField]}
          returned={data?.[metrics.returned.summaryField]}
          rate={data?.[metrics.rate.summaryField]}
        />
        <Styles.ChartContainer>
          {data?.results?.length > 0 ? (
            <ReturnSalesChart
              timeRangeSelected={filters?.timeRange}
              data={data?.results}
              metrics={metrics}
              loading={loading}
              timeDisplay={filters?.timeDisplayReturnSales}
              onChangeTimeDisplay={handleChangeTimeDisplay}
              showOpenInModal
              modalTitle={
                <Styles.ModalTitle>
                  <ArrowUDownLeftIcon size={24} />
                  {t('Tasa de devoluciones/ventas')}
                </Styles.ModalTitle>
              }
            />
          ) : (
            <NoResultsFound />
          )}
        </Styles.ChartContainer>
      </Styles.Container>
      <Alert type="warning">
        {t(
          'Esta información está sujeta a cambios, ya que productos adquiridos durante el periodo seleccionado aún pueden devolverse.'
        )}
      </Alert>
    </Styles.MainContainer>
  )
}

export default ReturnSalesRatioContent
